// String Prototype Extensions
/**
 * Returns a new string with the first letter capitalized.
 */
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

// Date Prototype Extensions
/**
 * Returns a moment object representing the Date object.
 */
Date.prototype.toMoment = function () {
  return moment(this)
}

Date.prototype.yesterday = function () {
  return moment(this).subtract(1, 'day').toDate()
}

Date.prototype.tomorrow = function () {
  return moment(this).add(1, 'day').toDate()
}